import React from 'react';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import Carousel from 'nuka-carousel';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import { updateMessageStatusRequest, messageStatusAction, changeMessageType, messageSendRequest } from '../redux/reducers/message';
import { messagesListRequest, messagesSentRequest } from '../redux/reducers/messagesList';
import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import {
  getTeamMembersFullRequest,
  resetSelectionMessage,
} from '../redux/reducers/teamMembersFull';
import { toggleViewMessage, toggleViewAttach, toggleNotification } from '../redux/reducers/view';
import { messageContentRequest } from '../redux/reducers/messageContent';

import { commonStyles, COLORS } from '../styles/styles';
import { getFileType, convertTimeToAgo } from '../utils';
import IframePopup from './Popups/IframePopup';
import LearnerInvitationMessage from './LearnerInvitationMessage';
import LearnerMessage from './LearnerMessage';

import { MESSAGE_TYPES } from '../constants';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBCol,
  MDBAnimation,
  MDBBadge,
  MDBIcon,
  MDBAlert} from "mdbreact";
import { selectRecipient } from '../redux/reducers/connectedUsers';
import { addTeamLeaderRequest } from '../redux/reducers/addTeamLeader';
import IframePopupAttach from './Popups/IframePopupAttach';

const LearnerMessageContent = ({
  classes,
  view,
  handlePopupToggle,
  toggleViewAttach,
  toggleViewMessage,
  resetSelectionMessage,
  messagesListRequest,
  messagesSentRequest,
  messageContent,
  attach,
  handleDeleteMessage,
  loginReducer,
  setViewMessage,
  authUser,
  handleDeclineInvite,
  handleAcceptInvite
}) =>
  messageContent.message !== null && (
    <MDBCard  className="z-depth-5 rounded-0 float-right col-lg-6 col-md-6 p-0 fixedCard">
      <div className='text-dark text-left p-3' onClick={()=>{
          setViewMessage(false);
          resetSelectionMessage();
          authUser();
          
          }}>
        <MDBIcon icon='times' className="primary-text" size="lg" style={{paddingRight:10}} />
        MESSAGE
      </div>
      {/* <MDBBtn
        floating
        right
        tag='a'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', right: 0}} 
        onClick={()=>setViewMessage(false)}
      >
      <MDBIcon icon='plus' className="success-color" size="md"/>
      </MDBBtn> */}
      <div className='text-dark md-copy text-left p-3 special-color'>
          From: {messageContent.message.data.sender.name}
      </div>
      <MDBCardBody className="contentScrollList" >
        <div className='text-dark md-copy text-left pt-1 '>Subject</div>
        <div className='text-dark md-copy-bold text-left pt-3 pb-2'>{messageContent.message.data.subject}</div>
        <div className='primary-color' style={{height:1, width:"100%"}}></div>
        <div className='text-dark md-copy text-left pt-4'>Message</div>
        <div className='text-dark md-copy mdb-color lighten-1 md-border-lighten2 text-left mt-2 mb-3 p-4'>{messageContent.message.data.message}</div>
        {messageContent.message.data.attachments &&  <div>
          <div className="xs-copy-ptsans" style={{width:'35%', float: 'right', textAlign:'right'}}>
            <MDBIcon style={{marginRight: 5, fontSize:18, marginTop:5}} className="light-grey-text" icon='paperclip'/>
          </div>
        {messageContent.message.data.attachments.map(item => (
          <div
            className={classes.attachmentItem}
            key={item.id}
            onClick={() => handlePopupToggle(item)}
          >
            <Typography className={classes.attachmentType}>
              {getFileType(item.type)}
            </Typography>
            <div className={classes.attachNameSizeWrap}>
              <Typography className={classes.attachInfo}>{item.name}</Typography>
            </div>
          </div>
        ))}
        </div>}
        <div style={{borderTop: '1px solid #D8D8D8', marginTop:20, textAlign:'right'}}>
          
         {messageContent.message.data.type.id==2 && (messageContent.message.data.status!='accept' && messageContent.message.data.status!='decline') ? <MDBRow className="mt-3">
           <MDBCol>
             <MDBBtn className="m-0 w-100" size="sm" color="success"  onClick={()=>{
          handleAcceptInvite()
          }}>
            Accept
          </MDBBtn>
          </MDBCol>
          <MDBCol>
            <MDBBtn className="m-0 w-100" size="sm" color="secondary"  onClick={()=>{
          handleDeclineInvite()
          }}>
            Decline
          </MDBBtn>
          </MDBCol>
          </MDBRow> : (messageContent.message.data.status=='accept' || messageContent.message.data.status=='decline') 
          ? messageContent.message.data.status=='accept' 
          ? <div style={{margin:5}}><MDBAlert color="success" dismiss >
          <MDBIcon icon="check-circle" /><strong> Accepted! </strong> You have accepted this invitation!
          </MDBAlert>
          <MDBRow className="mt-3"><MDBCol className="col-lg-6"></MDBCol><MDBCol className="col-lg-6 col-sm-12"><MDBBtn className="m-0 w-100" size="sm" color="success"  onClick={()=>{
          setViewMessage(false);
          resetSelectionMessage();
          authUser();
          messagesListRequest();
          messagesSentRequest();
          }}>
            Close
          </MDBBtn>
          </MDBCol>
          </MDBRow></div>
          
          
          :
          <div style={{margin:5}}><MDBAlert color="danger" dismiss >
          <MDBIcon icon="exclamation-circle" /><strong> Declined!</strong> You have declined this invitation!
          </MDBAlert>
          <MDBRow className="mt-3"><MDBCol className="col-lg-6"></MDBCol><MDBCol className="col-lg-6 col-sm-12"><MDBBtn className="m-0 w-100" size="sm" color="success"  onClick={()=>{
          setViewMessage(false);
          resetSelectionMessage();
          authUser();
          messagesListRequest();
          messagesSentRequest();
          }}>
            Close
          </MDBBtn>
          </MDBCol>
          </MDBRow></div>
          :
          <MDBRow className="mt-3"><MDBCol className="col-lg-6"></MDBCol><MDBCol className="col-lg-6 col-sm-12"><MDBBtn className="m-0 w-100" size="sm" color="success"  onClick={()=>{
          setViewMessage(false);
          resetSelectionMessage();
          authUser();
          messagesListRequest();
          messagesSentRequest();
          }}>
            Close
          </MDBBtn>
          </MDBCol>
          </MDBRow>}
          </div>
      </MDBCardBody>
      {view.isViewAttach && (
        <IframePopupAttach
          handlePopupToggle={toggleViewAttach}
          pathToIframeFile={attach.path}
          selectedContentItem={{ type: attach.type }}
          contentIframe={false}
          user = {loginReducer}
        />
      )}
</MDBCard>
    
  );

const styles = theme => ({
  ...commonStyles,
  fromControl: {
    minWidth: 120,
    marginTop: 29,
    marginBottom: 10,
    alignItems: 'center',
    height: 10,
    width: '100%',
    color: '#fff',
    fontSize: 14,
    fontWeight: theme.typography.fontWeightMedium,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexShrink: 0,
    fontFamily: 'Roboto',
  },
  messageHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    margin: 0,
    justifyContent: 'space-between',
  },
  messageFooterWrapper: {
    textAlign: 'right',
    paddingTop: 30,
    paddingBottom: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 50,
  },
  newMessage: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    borderRadius: 0,
    boxSizing: 'border-box',
    background: '#fff',
    padding: '20px',
    overflow: 'auto',
    flex: 2,
    width: 'calc(100% - 4px)',
    boxShadow: `0 0 0 2px ${COLORS.cornerstoneRed}`,
    margin: '2px 0',
  },
  messageBody: {
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    boxSizing: 'border-box',
    overflow: 'auto',
  },
});

const mapStateToProps = state => ({
  messageDelete: state.messageDeleteReducer,
  isLoggedIn: state.loginReducer.isLoggedIn,
  messageReducer: state.messageReducer,
  messageContent: state.messageContentReducer,
  teamMembersFull: state.teamMembersFullReducer,
  loginReducer: state.loginReducer,
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  updateMessageStatusRequest: messageId => dispatch(updateMessageStatusRequest(messageId)),
  messageStatusAction: action => dispatch(messageStatusAction(action)),
  messagesListRequest: () => dispatch(messagesListRequest()),
  messagesSentRequest: () => dispatch(messagesSentRequest()),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
  toggleViewMessage: value => dispatch(toggleViewMessage(value)),
  messageContentRequest: messageID => dispatch(messageContentRequest(messageID)),
  resetSelectionMessage: () => dispatch(resetSelectionMessage()),
  toggleViewAttach: value => dispatch(toggleViewAttach(value)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  changeMessageType: typeId => dispatch(changeMessageType(typeId)),
  messageSendRequest: messageContent => dispatch(messageSendRequest(messageContent)),
  selectRecipient: recipientId => dispatch(selectRecipient(recipientId)),
  addTeamLeaderRequest: () => dispatch(addTeamLeaderRequest()),
  toggleNotification: value => dispatch(toggleNotification(value)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('attach', 'handleAttach', null),
  withState('messageSent', 'messageSentChange', null),
  withHandlers({
    handlePopupToggle: props => item => {
      if (props.view.isViewAttach) {
        props.toggleViewAttach(false);
      }
      props.handleAttach(item);
      if(item.type=='pdf' || item.type=='jpg' || item.type=='png'){
        props.toggleViewAttach(true);
      }else{
        setTimeout(() => {
          const response = {
            file: item.path,
          };
          // server sent the url to the file!
          // now, let's download:
          window.open(response.file);
          // you could also do:
          // window.location.href = response.file;
        }, 100);
        props.toggleNotification({
          value: true,
          message: "Your file should be downloading! Check your downlaod folder.",
          type: 'success',
        });
      }
    },
    handleAcceptInvite: props => () => {
      const {
        changeMessageType,
        selectRecipient,
        messageSendRequest,
        messageSentChange,
        addTeamLeaderRequest,
        loginReducer
      } = props;
      changeMessageType(2);
      selectRecipient({ userId: props.messageContent.message.data.sender.id });
      messageSendRequest({
        subject: '- INVITATION -',
        message: loginReducer.user.firstName+' '+loginReducer.user.lastName+' has accepted your invitation and is now part of your team.',
        status: 'accept',
      });
      props.messageStatusAction('accept');
      props.updateMessageStatusRequest(props.messageContent.message.data.id);
      props.messagesListRequest();
      props.authUser();
      addTeamLeaderRequest();
      messageSentChange(true);
    },
    handleDeclineInvite: props => () => {
      const {
        changeMessageType,
        selectRecipient,
        messageSendRequest,
        messageSentChange,
        addTeamLeaderRequest,
        loginReducer
      } = props;
      changeMessageType(2);
      selectRecipient({ userId: props.messageContent.message.data.sender.id });
      messageSendRequest({
        subject: '- INVITATION -',
        message: loginReducer.user.firstName+' '+loginReducer.user.lastName+' has declined your invitation.',
        status: 'decline',
      });
      props.messageStatusAction('decline');
      props.updateMessageStatusRequest(props.messageContent.message.data.id);
      messageSentChange(true);
      props.messagesListRequest();
      props.authUser();
    },
    handleDeleteMessage: props => () => {
      const {
        messageStatusAction,
        updateMessageStatusRequest,
        toggleViewMessage,
        resetSelectionMessage,
        messagesListRequest,
        teamMembersFull,
      } = props;
      messageStatusAction('trash');
      updateMessageStatusRequest(teamMembersFull.selectedMessageId);
      toggleViewMessage(false);
      resetSelectionMessage();
      messagesListRequest();
      messagesSentRequest();
    },
  }),
  lifecycle({
    componentWillMount() {
      // @ToDo write correct statement
      // if (!this.props.messageContent.isFetched && this.props.teamMembersFull.selectedMessageId) {
      if (this.props.teamMembersFull.selectedMessageId) {
        this.props.messageContentRequest(this.props.teamMembersFull.selectedMessageId);
      }
    },
    componentWillReceiveProps(nextProps) {
      const { messageContent, messageContentRequest, teamMembersFull, authUser,messageSentChange } = nextProps;
      if (
        messageContent.selectedMessageId !== teamMembersFull.selectedMessageId &&
        !messageContent.fetching &&
        teamMembersFull.selectedMessageId
      ) {
        messageContentRequest(teamMembersFull.selectedMessageId);
      }
      
      if(!this.props.messageReducer.messageSent && nextProps.messageReducer.messageSent){
        
        this.props.toggleViewMessage(false);
        nextProps.messagesListRequest();
        nextProps.messagesSentRequest();
        messageSentChange(false);
        nextProps.setViewMessage(false);
        nextProps.toggleNotification({
          value: true,
          message: "Invite accepted successfuly!",
          type: 'success',
        });
      }
      const { messageDelete } = nextProps;
      if (messageDelete.deleted) {
        this.props.toggleViewMessage(false);
        nextProps.messagesListRequest();
        nextProps.messagesSentRequest();
      }
    },
    componentWillUnmount() {
      this.props.toggleViewMessage(false);
    },
  }),
  withStyles(styles),
)(LearnerMessageContent);
